module.exports = __webpack_public_path__ + "static/media/hello.9e1565a5.png";